export default __webpack_public_path__ + "media/images/lp/payment-sp-44c1c7b6c56962a91370ae9691e8069c.jpg";